module.exports = __webpack_public_path__ + "img/8diamante.fcafeaf2.png";